import React from 'react';
import { Footer } from './ProjectPageStyledComponents';

const ProjectPageFooter = () => {
    return (
        <Footer>
            <p>Design and developed by <a href="http://maruf.me/" target="_blank">Maruf Hasan</a></p>
        </Footer>
    );
}

export default ProjectPageFooter;